var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#535C64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.452 6.075C21.85 4.246 17.532 0 12 0 6.467 0 2.15 4.247.548 6.075a2.136 2.136 0 0 0 0 2.85C2.15 10.754 6.473 15 12.006 15c2.763 0 5.229-1.063 7.2-2.354 1.971-1.29 3.448-2.81 4.252-3.72a2.136 2.136 0 0 0 0-2.851h-.006zM12 12.225c-2.656 0-4.818-2.12-4.818-4.725 0-2.605 2.162-4.725 4.818-4.725 2.656 0 4.818 2.12 4.818 4.725 0 2.605-2.162 4.726-4.818 4.726z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.765c1.838 0 3.329-1.462 3.329-3.265 0-1.804-1.49-3.266-3.33-3.266-1.838 0-3.328 1.462-3.328 3.266 0 1.803 1.49 3.265 3.329 3.265z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye_open.458555b3.svg";
export { ForwardRef as ReactComponent };